import { isAndroid, isIOS } from './device';

/**
 * The app stores to offer on this device, as keys of `config.storeURLs`. A phone gets only its own store; a
 * computer can't tell which phone the client has, so it gets both.
 */
const getAppStores = () => {
  if (isIOS) {
    return ['ios'];
  }
  if (isAndroid) {
    return ['android'];
  }
  return ['ios', 'android'];
};

export default getAppStores;
